<template>
  <div>
    <StickyHeader />
    <v-container v-if="!readonly" class="flex-grow-1 py-0 pt-1 my-0" >
      <AlertTimeRange :point="point" :class="alertClass" />
      <PointInfo :delivery="deliveryMode" :class="alertClass"/>
    </v-container>
    <div v-for="(item, index) in sections"
         :key="`${item.id}-${index}`"
         :class="depthClass(item)"
    >
      <Section :item="item"
               :depth="item.depth"
               :active="sectionUI === item.id"
               :sticky-top="stickyTop"
      />
      <v-container>
        <v-row :id="item.id" dense>
          <component v-for="(product, index) in item.content"
                     :is="productComponent"
                     :key="index"
                     :item="product"
                     :menu="item.menu"
          />
        </v-row>
      </v-container>
    </div>
    <Fabs />
  </div>
</template>

<script>
import AlertTimeRange from '@/components/AlertTimeRange';
import PointInfo from '@/components/PointInfo';
import StickyHeader from '@/components/StickyHeader';
import Section from '@/components/Section';
import Fabs from '@/components/Fabs';

import ProductTile from '@/components/templates/ProductTile';
import ProductRow from '@/components/templates/ProductRow';
import ProductBrick from '@/components/templates/ProductBrick';

export default {
  name: 'Showcase',
  components: {
    Fabs, StickyHeader, PointInfo, AlertTimeRange, Section, ProductRow, ProductBrick, ProductTile
  },
  computed: {
    nav() { return this.$store.state.ui.navigation; },
    section() { return this.$route.params.section; },
    sectionUI() { return this.$store.state.ui.section; },
    stickyTop() {
      let out = 0;
      if (this.$store.state.theme.stickyHeader) {
        out += this.$store.state.theme.stickyHeaderHeight;
      }
      out += this.$store.state.ui.headerHeight;
      return out;
    },
  },
  watch: {
    section() {
      this.$store.commit('ui/section', this.section);
      this.autoscrollExecute();
    },
  },
  created() {
    this.point = this.$store.state.data.point;
    this.sections = this.$store.state.data.sections;
    this.productComponent = this.getProductComponent();
    this.deliveryMode = this.$store.state.data.mode !== 'pickup';
    this.readonly = this.$store.state.data.settings.readonly;
    this.alertClass = this.getAlertClass();
  },
  mounted() {
    this.$profiler.end('showcase')
    this.init();
    this.autoscrollExecute();
  },
  beforeCreate() {
    this.$profiler.start('showcase')
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.sectionUIUpdate);
  },
  methods: {
    getAlertClass() {
      const {
        stickyHeader, menuSectionRight, stickySection,
        navigationButton, navigationDesktop
      } = this.$store.state.theme;
      const navButtonHidden = !this.isMobile && navigationDesktop === 'constant';
      const marginsR = !navButtonHidden && !stickyHeader && menuSectionRight && stickySection;
      const marginsL = !navButtonHidden && !stickyHeader && !menuSectionRight && stickySection;
      return {
        'ml-16': marginsL && navigationButton === 'top-left-fab',
        'ml-12': marginsL && navigationButton === 'top-left',
        'pr-16': marginsR && navigationButton === 'top-right-fab',
        'pr-12': marginsR && navigationButton === 'top-right',
      }
    },
    getProductComponent() {
      const { mobile } = this.$store.state.ui;
      const { productTemplateMobile, productTemplate } = this.$store.state.theme;
      const template = (mobile && productTemplateMobile) ? productTemplateMobile : productTemplate;
      switch (template) {
        case 'row':
          return 'ProductRow';
        case 'brick':
          return 'ProductBrick';
        default:
          return 'ProductTile';
      }
    },
    init() {
      window.addEventListener('scroll', this.sectionUIUpdate);
    },
    sectionUIUpdate() {
      const top = this.stickyTop;
      const elements = document.querySelectorAll('.store-observed-section');
      let bestIndex = -1;
      let bestDelta = 1e6;
      for (let i = 0; i < elements.length; i++) {
        const rect = elements[i].getBoundingClientRect();
        if (rect.top === top) {
          this.$store.commit('ui/section', elements[i].id);
          return true;
        }
        if (rect.top < top && top - rect.top < bestDelta) {
          bestDelta = top - rect.top;
          bestIndex = i;
        }
      }

      if (bestIndex > -1) {
        this.$store.commit('ui/section', elements[bestIndex].id);
        return true;
      }

      this.$store.commit('ui/section', null);
      return false;
    },
    depthClass(depth) { return `store-depth-${depth}`; },
    autoscrollExecute() {
      const el = document.getElementById(`store-section-${this.section}`);
      if (el) {
        this.$vuetify.goTo(el, { duration: 0, offset: this.stickyTop });
      }
    },
  }
};
</script>
